/**
 * Document Picture-in-Picture: максимум, который сайт может честно назвать
 * «поверх окон». Одно такое окно на вкладку; вместе со сканером умирает.
 * Позицию страница не задаёт. Telegram и полный экран иногда перебивают.
 */

export type PipHost = {
  requestWindow: (opts?: {
    width?: number;
    height?: number;
    disallowReturnToOpener?: boolean;
    preferInitialWindowPlacement?: boolean;
  }) => Promise<Window>;
};

export function pipHost(): PipHost | null {
  const raw = (window as Window & { documentPictureInPicture?: PipHost }).documentPictureInPicture;
  if (raw === undefined || typeof raw.requestWindow !== 'function') return null;
  return raw;
}

export function canPip(): boolean {
  return pipHost() !== null;
}
